import { OrderType, SignedSaleOrder } from "@/api/orders/types";
import { isExpiredInSeconds } from "@/shared/dates";
import { useMemo } from "react";

export default function useTradeLabel(auction: SignedSaleOrder) {
  const isReserveAuction = useMemo(
    () => auction?.type === OrderType.RESERVE_AUCTION,
    [auction],
  );

  const isExpired = useMemo(
    () => isExpiredInSeconds(auction?.expiresAt),
    [auction],
  );

  return isReserveAuction
    ? isExpired && auction?.endingPrice
      ? "Winning bid"
      : !isExpired && auction?.endingPrice
        ? "Minimum bid"
        : "Reserve Price"
    : "Price";
}
